import {useState} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {createProject} from "../../../store/reducers/projectSlice";
import {Button, Container, ValidationError, Title, Form, Input, Label, DropdownContainer, Dropdown} from "./styled";
import ErrorMessage from "../../Shared/ErrorMessage";

const CreateProject = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [validationError, setValidationError] = useState(false);
  const [error, setError] = useState('');
  const [name, setName] = useState('');
  const [fusionMachineType, setFusionMachineType] = useState('');
  const [energyConversion, setEnergyConversion] = useState('');
  const [fuelType, setFuelType] = useState('');

  function empty(value) {
    return value === '';
  }

  const isFormValid = () => {
    return name !== '' &&
      fusionMachineType !== '' &&
      energyConversion !== '' &&
      fuelType !== '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      setValidationError(true);
      return;
    }
    setError('');
    setValidationError(false);

    const projectData = {
      name,
      fusionMachineType,
      energyConversion,
      fuelType
    };

    try {
      const resultAction = await dispatch(createProject(projectData)).unwrap();
      navigate(`/projects/${resultAction.projectId}`);
    } catch (rejectedValueOrSerializedError) {
      setError(rejectedValueOrSerializedError);
    }
  };

  return (
    <Container>
      <Title>New Project</Title>
      <Form onSubmit={handleSubmit}>
        <Label>Project Name:</Label>
        { empty(name) && validationError && <ValidationError>Please enter a project name.</ValidationError> }
        <Input
          type="text"
          placeholder="Enter project name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <DropdownContainer>
          <Label htmlFor="fusionMachineType">Fusion machine type:</Label>
          { empty(fusionMachineType) && validationError && <ValidationError>Please select a fusion machine type.</ValidationError> }
          <Dropdown
            id="fusionMachineType"
            value={fusionMachineType}
            onChange={(e) => setFusionMachineType(e.target.value)}
          >
            <option value="">Select a fusion machine type</option>
            <option value="MFE">Magnetic Fusion Energy (MFE, Tokamak)</option>
            <option value="IFE">Inertial Fusion Energy (IFE. Lasers)</option>
            {/* Commented out until implementation is complete */}
            {/*<option value="MIF">Magneto-Inertial Fusion (MIF, Hybrid)</option>*/}
          </Dropdown>
        </DropdownContainer>
        <DropdownContainer>
          <Label htmlFor="energyConversion">Energy Conversion:</Label>
          { empty(fusionMachineType) && validationError && <ValidationError>Please select an energy conversion.</ValidationError> }
          <Dropdown
            id="energyConversion"
            value={energyConversion}
            onChange={(e) => setEnergyConversion(e.target.value)}
          >
            <option value="">Select energy conversion</option>
            <option value="DIRECT">Direct</option>
            <option value="TURBINE">Turbine</option>
          </Dropdown>
        </DropdownContainer>
        <DropdownContainer>
          <Label htmlFor="fuelType">Fuel Type:</Label>
          { empty(fuelType) && validationError && <ValidationError>Please select a fuel type.</ValidationError> }
          <Dropdown
            id="fuelType"
            value={fuelType}
            onChange={(e) => setFuelType(e.target.value)}
          >
            <option value="">Select fuel type</option>
            <option value="DT">DT</option>
            <option value="PB11">Pb11</option>
            {/*<option value="DHE3">DHe3</option>*/}
          </Dropdown>
        </DropdownContainer>
        <Button type="submit">Create Project</Button>
        {error && <ErrorMessage message={error} />}
      </Form>
    </Container>
  );
};

export default CreateProject;